import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
export default [
    {
        path: '/image-preview',
        name: 'image.preview',
        view: 'images/ImagePreview',
        middlewares: [RequireUserMiddleware],
    },
]
